<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        人员申报审批
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item  prop="coId">
            <el-select v-model="queryParams.coId" filterable placeholder="所属企业">
              <el-option label="全部" value="" />
              <el-option v-for="item in company2" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.name" placeholder="姓名" clearable/>
          </el-form-item>
          <el-form-item prop="declareType">
            <el-select v-model="queryParams.declareType" placeholder="申报类型">
              <el-option label="全部" value="" />
              <el-option v-for="item in declaretype" :key="item.code" :label="item.name" :value="parseInt(item.code)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="declareType">
            <el-select v-model="queryParams.checkStatus" placeholder="审批状态">
              <el-option label="全部" value="" />
              <el-option v-for="item in option2" :key="item.value" :label="item.label" :value="parseInt(item.value)">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            <el-button
              :disabled="multiple"
              type="primary"
              style="margin-left:15px"
              @click="moreCheck"
              >批量审批
            </el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList" @selection-change="handleSelectionChange" :show-overflow-tooltip="true">
          <el-table-column align="center" type="selection" width="50" :selectable="checkSelectable"/>
          <el-table-column align="center" label="姓名" prop="name" width="80" />
          <el-table-column align="center" label="联系方式" prop="mobile" width="110" />
          <el-table-column align="center" label="身份证号" prop="idCard" width="116" show-overflow-tooltip/>
          <el-table-column align="center" label="性别" prop="sex" width="60" />
          <el-table-column align="center" label="年龄" prop="age" width="60" />
          <el-table-column align="center" label="人员状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.personStatus == 1">在职</span>
              <span v-if="scope.row.personStatus == 2">离职</span>
              <span v-if="scope.row.personStatus == 99">其他</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="到访企业" prop="coName" show-overflow-tooltip/>
          <el-table-column align="center" label="有效期始" prop="validityPeriodStart" width="92" />
          <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="92" />
          <el-table-column align="center" label="通行类型" prop="passType" width="92">
            <template slot-scope="scope">
              <span v-if="scope.row.passType == 1">人脸用户</span>
              <span v-if="scope.row.passType == 2">IC卡用户</span>
              <span v-if="scope.row.passType == 3">人脸+IC卡用户</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申报类型" prop="declareType" width="92">
            <template slot-scope="scope">
              <span v-if="scope.row.declareType == 1">企业申报</span>
              <span v-if="scope.row.declareType == 2">临时申报</span>
              <span v-if="scope.row.declareType == 3">通勤申报</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申报时间" prop="createTime" width="100" />
          <el-table-column align="center" label="审批状态" prop="checkStatus" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatus == 0"><b>未审批</b></span>
              <span v-if="scope.row.checkStatus == 1" style="color: green;"><b>审批通过</b></span>
              <span v-if="scope.row.checkStatus == 2" style="color: red;"><b>审批未通过</b></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="事由" prop="reason" width="100" show-overflow-tooltip v-if="queryParams.declareType == 2 ||queryParams.declareType == ''"/>
          <el-table-column align="center" label="备注" prop="remark" width="100" show-overflow-tooltip v-if="queryParams.declareType != 2 ||queryParams.declareType == ''"/>
          <el-table-column align="center" label="操作" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.checkStatus == 0" type="success" size="mini" circle plain
                @click.stop="handleApproval(scope.row)">审批</el-button>
              <el-button type="info" size="mini" circle plain @click.stop="handleDetail(scope.row)">详情</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20, 30, 40, 50, 100]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>

    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form"  label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="coId">
              <el-select v-model="form.coId" placeholder="" disabled>
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="姓名" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="mobile">
              <el-input v-model="form.mobile" placeholder="手机号" type="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="身份证" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="form.sex" placeholder="" disabled>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年龄" prop="age">
              <el-input v-model="form.age" placeholder="年龄" tyep="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员状态" prop="personStatus">
              <el-select v-model="form.personStatus" placeholder="" disabled>
                <el-option v-for="item in personstatus" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期始" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="validityPeriodEnd">
              <el-date-picker v-model="form.validityPeriodEnd"  value-format="yyyy-MM-dd"
                type="date" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申报时间" prop="createTime">
              <el-input v-model="form.createTime" placeholder="申报时间" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.declareType == 1">
            <el-form-item label="每日访问时段" prop="passTime">
              <el-input v-model="form.passTime" placeholder="每日访问时段" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通行类型">
              <el-select v-model="form.passType" placeholder="" disabled>
                <el-option v-for="item in passtype" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事由" v-if="form.declareType != 1">
              <el-input v-model="form.reason" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="form.remark" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审批意见">
              <el-input v-model="form.checkOpinion" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="头像照片">
              <img :src="form.avatar" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.avatar)">
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="港区证明文件" v-if="form.declareType == 1">
              <img :src="form.proveFile" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.proveFile)">
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="健康码" v-if="form.declareType == 2">
              <img :src="form.ykCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.ykCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行程码" v-if="form.declareType == 2">
              <img :src="form.xcCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.xcCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核酸报告" v-if="form.declareType == 2">
              <img :src="form.yyCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.yyCode)">
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="审批详情" :visible.sync="dialogVisible" width="50%" custom-class="zlkgl"
      :close-on-click-modal="false">
      <el-form :model="form" ref="form1" :rules="rules">
        <el-form-item label="审批状态" prop="checkStatus">
          <el-radio-group v-model="form.checkStatus">
            <el-radio :label="item.value" :key="item.value" v-for="item in isCheckStatus">{{item.label}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见内容" prop="checkOpinion">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.checkOpinion">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSubmit(1)" :loading="loadingbut" v-if="!buttonVisible">{{buttontext}}</el-button>
        <el-button type="primary" @click="dialogSubmit(2)" :loading="loadingbut" v-if="buttonVisible">{{buttontext}}</el-button>
      </span>
    </el-dialog>

    <el-image-viewer
      v-if="!!bigImgSrc"
      :on-close="closeImgViewer"
      :url-list="[bigImgSrc]"
    />
  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  import ElImageViewer from "@/components/CustomImageViewer";
  export default {
    name: "person-management",
    components: {
      commonPagination,ElImageViewer
    },
    props: {},
    data() {
      return {
        declaretype: JSON.parse(sessionStorage.getItem('dictionary')).DECLARETYPE,
        checkstatus: JSON.parse(sessionStorage.getItem('dictionary')).CHECKSTATUS,
        personstatus:JSON.parse(sessionStorage.getItem('dictionary')).PERSONSTATUS,
        passtype:JSON.parse(sessionStorage.getItem('dictionary')).PERSONPASSTYPE,
        company:JSON.parse(localStorage.getItem('company')),
        company2:[],
        option2: [ {
          value: 0,
          label: '未审批'
        }, {
          value: 1,
          label: '审批通过'
        }, {
          value: 2,
          label: '审批未通过'
        }, {
          value: 3,
          label: '已审批'
        }],
        options: [{
          value: '男',
          label: '男'
        }, {
          value: '女',
          label: '女'
        }],
        bigImgSrc: "",
        dialogVisible: false,
        loadingbut:false,
        buttontext:"提 交",
        buttonVisible:false,
        // 遮罩层
        dataForm2: {
          id: 0,
          ids:[],
          checkStatus: null,
          checkOpinion: null
        },
        isCheckStatus: [{
            label: "审批通过",
            value: 1
          },
          {
            label: "审批未通过",
            value: 2
          }
        ],

        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParams: {
          declareType: undefined,
          checkStatus: undefined
        },
        queryParam: {
          pageIndex: 0,
          pageRow: 300,
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: true
        },
        apiUrl: {
          approvalApi: 'POST_hyPersonDeclareVerify',
          indexApi: 'POST_hyPersonDeclareCheck',
          delApi: 'GET_hyPersonDeclareDelete',
          detailApi: 'GET_hyPersonDeclareFind',
          Enterpriseinfo: 'POST_hyEnterpriseByRole'
        },
        // 表单参数
        form: {
          age: 0,
          avatar: "",
          coId: "",
          declareType: 1,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "",
          passType: "",
          personStatus: "",
          reason: "",
          remark: "",
          sex: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          checkStatus: null,
          checkOpinion: null
        },
        // 表单校验
        rules: {
          checkStatus: [{
            required: true,
            message: "不能为空",
            trigger: "change"
          }],
          checkOpinion: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }]
        }
      };
    },
    methods: {
      async loadData() {
        let declareType = this.$route.params.declareType;
        let checkStatus = this.$route.params.checkStatus;
        if (declareType != null) {
          this.queryParams.declareType = declareType;
          this.queryParams.checkStatus = checkStatus;
        }
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = 1;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
        this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
          const {
            data,
            total
          } = response;
          if (response.code == '00000') {
            this.pageList = data;
            this.pagination.total = total;
            this.loading = false;
          } else {
            this.$message.error(response.msg);
            this.pageList = data;
            this.pagination.total = total;
            this.loading = false;
          }
        });
      },
      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      async handleApproval(res) {
        this.buttonVisible =false;
        this.dialogVisible = true;
        const data = JSON.parse(JSON.stringify(res));
        this.form = data;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      moreCheck() {
        this.form.checkOpinion = "";
        this.form.checkStatus = 0;
        this.buttonVisible = true;
        this.dialogVisible = true;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      dialogSubmit(type) {
        this.$refs["form1"].validate(valid => {
          if (valid) {
            if(this.form.checkStatus == 0){
              this.$message.error("请选择审批状态！");
            }else{
                if(type == 1){
                  this.loadingbut = true;
                  this.buttontext = "提交中..."
                  this.dataForm2.id = this.form.id
                  this.dataForm2.checkOpinion = this.form.checkOpinion
                  this.dataForm2.checkStatus = this.form.checkStatus
                  this.$http.POST_hyPersonDeclareVerify(this.dataForm2).then(res => {
                    if (res.code == '00000') {
                      this.$message.success(res.data);
                      this.handleQuery();
                      this.dialogVisible = false;
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    } else {
                      this.$message.error("审批失败" + res.msg);
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    }
                  })
                }else{
                  this.loadingbut = true;
                  this.buttontext = "批量提交中..."
                  this.dataForm2.ids = this.ids
                  this.dataForm2.checkOpinion = this.form.checkOpinion
                  this.dataForm2.checkStatus = this.form.checkStatus
                  console.log(this.dataForm2)
                  this.$http.POST_hyPersonDeclareBatchCheck(this.dataForm2).then(res => {
                    if (res.code == '00000') {
                      this.$message.success(res.data);
                      this.handleQuery();
                      this.dialogVisible = false;
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    } else {
                      this.$message.error("审批失败" + res.msg);
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    }
                  })
                }
              }
          }
        });
      },
      async handleDetail(row) {
        this.resetForm();
        this.dialog = {
          title: "申报详情",
          visible: true,
          flag: false
        };
        const id = row.id || this.ids;
        this.$http[this.apiUrl.detailApi]({
          paramsID: id
        }).then(response => {
          if(response.code == '00000'){
            this.form = response.data;
          }else{
            if(response.msg==null)
            this.$message.error("获取数据失败！");
            else{
              this.$message.error(response.msg);
            }
          }
        });
      },
      handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: id
          }).then(response => {
            if(response.code == '00000'){
              this.$message.success("删除成功");
              this.handleQuery();
            }else{
              this.$message.error(response.msg);
            }
          });
        }).catch(() => {});
      },
      handlePictureCardPreview(file) {
        this.bigImgSrc = file;
      },
      closeImgViewer(){
        this.bigImgSrc = false;
      },
      getCompany(){
        this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(res => {
          if(res.data.length>1){
            res.data.forEach((element, key) => {
              this.company2.push({
                lable: element.coName,
                value: element.id,
              });
            });
          }else{
            this.company2.push({
              lable: res.data.coName,
              value: res.data.id,
            });
          }
        });
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
          this.ids = [];
          selection.forEach(s => {
                if(s.checkStatus == 0){
                  this.ids.push(s.id)
                }
            })
          //this.ids = selection.map(item => (item.id));
          this.single = selection.length !== 1;
          this.multiple = !selection.length;
      },
      //已审批不可选中
      checkSelectable(row,index){
         let flag = true;
         if(row.checkStatus != 0){
           flag = false
         }
         return flag
       },
      // 表单重置
      resetForm() {
        this.form = {
          age: 0,
          avatar: "",
          coId: "",
          declareType: 1,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "",
          passType: "",
          personStatus: "",
          reason: "",
          remark: "",
          sex: "",
          validityPeriodEnd: "",
          validityPeriodStart: ""
        };
        if (this.$refs["form"]) {
          this.$nextTick(() => {
          this.$refs["form"].resetFields();
          })
        }
      }
    },
    created() {
      this.loadData();
      this.getCompany();
    },
    watch: {

    }
  };
</script>

<style >
.el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/views/sbgl/sbrysp.vue